import AddBannerElement from './addBannerElement.vue';

import Vue from 'vue';

export const vmAddBannerElement = new Vue({
  components: { AddBannerElement },
  template: '<AddBannerElement v-bind:valueProps="value" v-bind:isActiveProps="isActive" />',
  data () {
    return {
      value: {},
      isActive: false
    };
  }
});
